import React from 'react';
import photo1 from '../assets/equipe/chef.jpg';
import photo2 from '../assets/equipe/membre.jpeg';
import photo3 from '../assets/equipe/membre2.jpeg';

const equipe = [
  {
    nom: 'Edvard F. Edouard',
    // poste: 'Co-Fondateur & CEO',
    bio: 'Visionnaire et leader technique d\'EFE Systems, il pilote la stratégie et l\'innovation de l\'entreprise.',
    photo: photo1,
    est_chef: true,
    linkedin: 'https://www.linkedin.com/in/evardfe/',
    email: 'edvard.edouard@efe-systems.com',
  
  },
  {
    nom: 'Peter Beausejour',
    poste: 'Responsable des Projets',
    bio: 'Coordonne les projets numériques et veille à leur réussite, de la conception à la livraison.',
    photo: photo2,
    est_chef: false,
    linkedin: 'https://www.linkedin.com/in/peterbeausejour/',
    email: 'peter.beausejour@efe-systems.com',
  
  },
  {
    nom: 'Wilson Fleurimond',
    poste: 'Responsable Technique',
    bio: 'Pilote l’innovation technologique et supervise le développement des solutions numériques d’EFE Systems.',
    photo: photo3,
    est_chef: false,
    linkedin: 'https://www.linkedin.com/in/wilson-fleurimond/',
    email: 'wilsonfleurimond@efe-systems.com',
  
  },
];

function Equipe() {
  return (
    <section id="equipe" className="py-24 px-6" style={{ background: '#e6e6e7' }}>
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm mb-4"
            style={{ background: 'rgba(26,26,230,0.08)', border: '1px solid rgba(26,26,230,0.2)', color: '#1A1AE6' }}>
            Notre Équipe
          </div>
          <h2 className="text-4xl font-extrabold mb-4" style={{ color: '#0F0F2D' }}>
            Les esprits derrière EFE Systems
          </h2>
          <p className="text-gray-500 text-lg max-w-lg mx-auto">
            Trois fondateurs, une vision commune : bâtir l'avenir numérique d'Haïti.
          </p>
        </div>

        {/* Cartes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          {equipe.map((membre, index) => (
            <div key={index} className="relative flex flex-col items-center">

              {/* Photo cercle flottante AU DESSUS */}
              <div className="w-32 h-32 rounded-full overflow-hidden z-10 shadow-xl"
              style={{ marginBottom: '-80px' }}>
                <img
                  src={membre.photo}
                  alt={membre.nom}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Carte infos EN BAS */}
           <div className="w-full rounded-3xl pt-24 pb-6 px-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                style={{
                  background: '#fff',
                  border: membre.est_chef ? '1px solid rgba(26,26,230,0.3)' : '1px solid rgba(0,0,0,0.07)',
                  boxShadow: membre.est_chef ? '0 4px 30px rgba(26,26,230,0.08)' : '0 2px 15px rgba(0,0,0,0.05)',
                }}>

                {/* Badge CEO */}
                {membre.est_chef && (
                  <div className="flex justify-center mb-3">
                    <span className="px-3 py-1 rounded-full text-xs font-bold"
                      style={{ background: '#1A1AE6', color: 'white' }}>
                      Directeur
                    </span>
                  </div>
                )}

                {/* Nom & Poste */}
                <h3 className="text-lg font-extrabold text-center mb-1" style={{ color: '#0F0F2D' }}>
                  {membre.nom}
                </h3>
                <p className="text-sm font-medium text-center mb-3" style={{ color: '#1A1AE6' }}>
                  {membre.poste}
                </p>

                {/* Bio */}
                <p className="text-gray-400 text-sm leading-relaxed text-center mb-5">
                  {membre.bio}
                </p>

                {/* Compétences */}
             

                {/* Boutons */}
                <div className="border-t border-gray-100 pt-4 flex justify-center gap-3">
                  
               <a href={membre.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold transition hover:opacity-80"
                    style={{ background: '#0A66C2', color: 'white' }}
                  >
                    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="white">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                  
                  <a   href={`mailto:${membre.email}`}
                    className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold transition hover:opacity-80"
                    style={{ background: '#EA4335', color: 'white' }}
                  >
                    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="white">
                      <path d="M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                    Contacter
                  </a>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Equipe; 